import React from 'react'
import { WorkListClientNeeds } from './WorkListClientNeeds'
import { useWorkListViewRopStore } from '../../../context/WorkListViewStore/Rop/WorkListViewStore.rop'

const WorkListClientNeedsTab = () => {
  const {
    store: { wlData }
  } = useWorkListViewRopStore()
  return <WorkListClientNeeds isDisabled commentsRSE={wlData?.commentsRSE} />
}
export default WorkListClientNeedsTab
